import http from "./main";

export default {
    getImagesForAppointment: async (appointmentId) => {
        return await http.get(`images/${appointmentId}`);
    }
}